<script setup lang="ts">
interface Emit {
  (e: 'update:modelValue', value: boolean): void
}

interface Props {
  modelValue: boolean
  code: number
  message: string
}

const props = defineProps<Props>()
const emit = defineEmits<Emit>()

const handleModelChange = (value: boolean) => {
  emit('update:modelValue', value)
}

const color = ref()
const text = ref()
const icon = ref()

const location = 'top end'
const variant = 'flat'

const handleChange = () => {
  const statusCode = props.code

  text.value = props.message

  if (statusCode >= 200 && statusCode < 300) {
    color.value = 'success'
    icon.value = 'tabler-check'
  } else if (statusCode >= 400) {
    color.value = 'error'
    icon.value = 'tabler-circle-off'
  } else {
    color.value = 'info'
    icon.value = 'tabler-info-circle'
  }
}

watch(
  () => props.modelValue,
  () => {
    handleChange()
  },
)
</script>

<template>
  <VSnackbar
    :model-value="props.modelValue"
    :location="location"
    :variant="variant"
    :color="color"
    icon="tabler-school"
    @update:model-value="handleModelChange(!modelValue)"
    @click="handleModelChange(!modelValue)"
  >
    <VIcon class="pr-8" dark large :icon="icon" />
    {{ text }}
  </VSnackbar>
</template>
